/**
 * The refusal code of a tier-gated route (`resolveTierFeatureAccess` on the
 * server, #1897): a 403 whose body carries `tier_not_eligible` or
 * `feature_disabled`. Anything else — another 403 (not the viewer's
 * projects), another status, an unknown code — is `null`: not a plan matter.
 */
import {
  tierFeatureRefusalSchema,
  type TierFeatureRefusal,
} from '@aica/api-types/schemas';

export function tierRefusalCode(error: unknown): TierFeatureRefusal | null {
  const failure = error as { status?: unknown; data?: unknown } | null;
  if (failure?.status !== 403) return null;
  const code = (failure.data as { code?: unknown } | null | undefined)?.code;
  const parsed = tierFeatureRefusalSchema.safeParse(code);
  return parsed.success ? parsed.data : null;
}
